import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames, AppMetaDataService } from '../../../meta-data/app-meta-data.service';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import { CodeValuePermitTeam, EthosWachterDepartmentAllItems, PermitsMetaDataItemNames } from '../meta-data/permits-meta-data.service';
import { PermitTeamData } from '../models/permit-team-data.model';
import { PermitRequestService } from '../services/permit-request.service';
import { WachterDivisions } from '../meta-data/constants/wachter-divisions.enum';
import { WachterTeams } from '../meta-data/constants/wachter_teams.enum';

@DwCustomContextDefinition({
    keyName: 'permitTeamDefaultContext',
    display: 'Permit Team Default',
    isGlobal: true,
    item: PermitsMetaDataItemNames.PermitRequest
})
@Injectable()
export class PermitTeamDefaultContextService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        private permitRequestService: PermitRequestService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            return this.getDefaultPermitTeam(resolvedContext);
        });

        contextDef.attributes = [];

        // Adding a custom attribute to the context so we can select it in the user interface
        this.addProperty(contextDef.attributes, "PermitTeamCodeValueId", "Permit Team Code Value Id", DwAttributeType.Integer);
        //this.addProperty(contextDef.attributes, "CriticalPower", "Critical Power", DwAttributeType.YesNo);

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
    }

    getDefaultPermitTeam(resolvedContext: any): Observable<PermitTeamData> {
        const trustUser = new WachterUserExt(this.dwSecurityUserService.securityState.securityContext?.ApplicationUser);

        return this.permitRequestService.getWachterDivisionId(trustUser.wachterDepartmentId)
            .pipe(map(divisionId => {
                return this.getPermitTeamData(divisionId, trustUser);
            }));
    }

    getPermitTeamData(wachterDivisionId: number, trustUser: WachterUserExt): PermitTeamData {
        const permitTeamData: PermitTeamData = {};

        // Set a default so we know it is working
        permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NSPLBU;
        permitTeamData.CriticalPower = false;

        /* Rules from WI 54239
       
           NSP (WachterDivisionId=5) - NSP
           LBU (WachterDivisionId=8)- NSP
           WEC (WachterDivisionId=3) - WEC
           NES (WachterDivisionId=3 AND WachterDepartmentId=26 )- NES 
           Rollout (Departmentid= 5 AND WachterDepartmentId=39) - Rollout
       
           */
        
        // Default is NSP (this handle NSP & LBU)
        permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NSPLBU;

        // Division is WEC (3), but in the DB it's called industrial
        if (wachterDivisionId == WachterDivisions.Industrial) {
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.WEC;
        }

        
        // Department is NES
        if (trustUser.wachterDepartmentId == EthosWachterDepartmentAllItems.NWElectricalService) { // Used to be 26, but that's WECElectricalManagement
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NES;
        }

        // Department is Rollout
        if (trustUser.wachterDepartmentId == EthosWachterDepartmentAllItems.NWRollout) { // 39
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.Rollout;

            // Team is Critical Power
            if (trustUser.wachterTeamtId == WachterTeams.Rollout_Critical_Power) { // 264
                permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.CRITICALPOWER;
                permitTeamData.CriticalPower = true;
            }

            return permitTeamData;
        }

        return permitTeamData;
    }
}